var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-align-center box-pack-between main"},[_c('div',{staticClass:"whiteBg",staticStyle:{"padding":"20px"}},[_c('export-more-file',{ref:"exportMoreFile"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }